export const getShortAddress = (address?: string) =>
  address &&
  `${address.slice(0, 4)}...${address?.slice(address?.length - 3, address?.length)}`;
